import { FC } from 'react'
import { useDispatch } from 'react-redux'
import { closeModal } from 'store/actions/modals'
import { Button } from 'components/Forms'

import { t } from 'translations'

interface ConfirmCancelButtonsProps {
  handleSubmit?: () => void
  disabled: boolean
  isSubmitting?: boolean
}

export const ConfirmCancelButtons: FC<ConfirmCancelButtonsProps> = ({ handleSubmit, disabled, isSubmitting }) => {
  const dispatch = useDispatch()

  return (
    <div>
      <Button type="submit" isSubmitting={isSubmitting} className="mr-2 btn btn-primary" onClick={handleSubmit || null} disabled={disabled}>
        {t(`actions.CONFIRM_CHANGES`)}
      </Button>
      <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
        {t(`actions.CANCEL`)}
      </Button>
    </div>
  )
}
